<template>
  <div class="common-header">
    <div class="common-box">
      <div class="top-box">
        <div class="logo" @click="goIndex()">
          <img :src="logo" alt srcset />
        </div>
        <div class="list">
          <div
            class="list-item"
            v-for="(item, index) in titleList"
            :key="index"
            :class="item.link_address == pathName ? 'active' : ''"
            @click="changeTitle(item)"
            @mouseenter="clearfix(item)"
            @mouseleave="leave(item)"
          >
            {{ item.navigation_title }}
            <!-- <i
              class="el-icon-caret-bottom"
              v-show="item.link_address === 'login'"
            ></i> -->
            <div
              class="login-box"
              v-if="item.link_address === 'login'"
              v-show="loginShow"
            >
              <a href="">沃沃农贸登陆</a>
              <a href="">沃沃农批登陆</a>
              <a href="">沃沃农贸登陆</a>
              <a href="">沃沃农贸登陆</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CommonHeader",
  props: {
    pathName: {
      type: String,
      default() {
        return "";
      }
    },
    headerType: {
      type: String,
      default() {
        return "1";
      }
    }
  },
  data() {
    return {
      loginShow: false,
      logo: require("@/assets/images/logo.png"),
      titleList: [
        {
          link_address: "index",
          navigation_title: "首页"
        },
        {
          link_address: "company-profile",
          navigation_title: "关于沃沃"
        },
        {
          link_address: "solution",
          navigation_title: "解决方案"
        },
        {
          link_address: "news",
          navigation_title: "新闻中心"
        },
        {
          link_address: "products",
          navigation_title: "产品服务"
        },
        {
          link_address: "successful-cases",
          navigation_title: "经典案例"
        },
        {
          link_address: "application",
          navigation_title: "平台登录"
        },
        // {
        //   link_address: "login",
        //   navigation_title: "平台登录",
        // },
        {
          link_address: "contact-us",
          navigation_title: "联系我们"
        },
        {
          link_address: "supply-chain",
          navigation_title: "供应链"
        },
        {
          link_address: "social-responsibility",
          navigation_title: "社会责任"
        },
        {
          link_address: "recruit",
          navigation_title: "人才招聘"
        }
      ]
    };
  },
  mounted() {},
  methods: {
    changeTitle(item) {
      if (item.link_address != "login") {
        this.$router.push({
          name: item.link_address
        });
      }
    },
    goIndex() {
      this.$router.push({
        name: "index"
      });
    },
    clearfix(item) {
      if (item.link_address == "login") {
        // this.loginShow = true;
      }
    },
    leave(item) {
      if (item.link_address == "login") {
        // this.loginShow = false;
      }
    }
  }
};
</script>
<style scoped>
.common-header {
  width: 100%;
  height: 100px;
  background: rgb(255, 255, 255);
  box-shadow: 0px 1px 13px 0px rgba(204, 204, 204, 0.34);
  position: fixed;
  top: 0px;
  z-index: 9999;
  line-height: 100px;
}
.common-box {
  width: 1232px;
  height: 100%;
  margin: 0px auto;
  display: flex;
}
.top-box {
  width: 1240px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.top-box .logo img {
  width: 150px;
  height: 50px;
  vertical-align: middle;
  cursor: pointer;
}
.list {
  flex: 1;
  line-height: 100px;
  display: flex;
  justify-content: space-between;
  margin: 0 20px 0 80px;
}
.list-item {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333;
  cursor: pointer;
  position: relative;
}
.list-item.active,
.list-item:hover {
  color: #006f4b;
}
.list-item.active::after,
.list-item:hover::after {
  position: absolute;
  width: 40px;
  height: 2px;
  background: #006f4b;
  content: "";
  bottom: 30px;
  left: 50%;
  margin-left: -20px;
}
.login-box {
  width: 160px;
  height: 200px;
  background-color: #f5f5f5;
  position: absolute;
  top: 70px;
  right: 0;
  box-sizing: border-box;
  padding: 20px;
}
.login-box a {
  display: block;
  line-height: 40px;
  color: #333;
}
.login-box a:hover {
  color: #006f4b;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonHeader.vue